export default function byType<T extends { type: string }>(
  obj: T[],
  ...types: T["type"][]
): T[] {
  return obj.filter((a) => types.includes(a.type));
}
